import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 日程
import Schedule from './components/schedule';
import Improve from '@/views/settings/invite/modal/Improve';
import Chart from './components/chart';
import Probation from './components/probation';
import { typeInfoFn, listFn, createFn, delFn, editFn, hasSpotFn, attendanceFn, servingFn, orgFn, flowFn, tabCount, gettodayleaveoffice, exportleaveoffice, getStaffRegular as _getStaffRegular // 待转正列表
} from 'api/dashboard';
import { getPendingList, inviteApproval } from 'api/settings';
import { formatDate, formatDay } from './formatDate';
// 日程默认信息
var scheduleForm = function scheduleForm() {
  return {
    type: 0,
    topic: '',
    start_time: '',
    end_time: '',
    place: '',
    start_date: '',
    end_date: ''
  };
};
export default {
  name: 'Dashboard',
  components: {
    Schedule: Schedule,
    Chart: Chart,
    Improve: Improve,
    Probation: Probation
  },
  data: function data() {
    var _this = this;
    var self = this;
    return {
      // 员工流动情况天数选择
      radioSelect: 7,
      isImprove: false,
      // tabs当前索引选项
      activeName: this.$route.query.active || '0',
      scheduleList: {
        count: 0
      },
      scheduleType: [],
      // 添加日程
      dialogVisible: false,
      scheduleForm: scheduleForm(),
      rules: {
        topic: [{
          required: true,
          message: this.$t('1120'),
          trigger: 'blur'
        }],
        start_time: [{
          required: true,
          message: this.$t('1116'),
          trigger: 'blur'
        }],
        end_time: [{
          validator: function validator(rule, value, callback) {
            var start_time = self.scheduleForm.start_time;
            // 值必须存在
            if (!value) {
              return callback(new Error(self.$t('1116')));
            }
            var start = start_time && start_time.getTime();
            var end = value && (value.getTime && value.getTime() || value);
            // 结束时间必须大于开始时间
            if (start > end) {
              return callback(new Error(self.$t('1130')));
            }
            // 正确
            callback();
          },
          trigger: 'blur'
        }]
      },
      // 开始时间——不能选今天之前的日期
      pickerOptionsStart: {
        disabledDate: function disabledDate(time) {
          var now = Date.now();
          return time.getTime() < now - 8.64e7;
        }
      },
      // 结束时间——不能比开始时间小
      pickerOptionsEnd: {
        disabledDate: function disabledDate(time) {
          if (_this.scheduleForm.start_time) {
            return time.getTime() < new Date(_this.scheduleForm.start_time).getTime() - 8.64e7;
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      // 有日程的列表
      includeSchedule: [],
      isAdd: true,
      // 代办
      toDoList: [],
      toRegular: {
        // 待转正[滚动加载]
        page: 1,
        page_size: 5,
        search_name: '',
        loading: false,
        finished: false,
        total: 0,
        list: []
      },
      // 待离职[滚动加载]
      toResign: {
        list: [],
        finished: false,
        page: 1,
        page_size: 5,
        loading: false,
        search: ''
      },
      attendanceData: {},
      servingData: {},
      orgData: {},
      flowData: {},
      tabCountMap: {
        invite: 0,
        leave: 0,
        regular: 0
      },
      isEdit: false,
      // 编辑或者新增日程(通过状态关联开始结束时间)
      isProbationSet: this.$route.query.name // 点击设置提醒
    };
  },
  mounted: function mounted() {
    this.init();
  },
  watch: {
    // 结束时间必须大于开始时间
    'scheduleForm.start_time': function scheduleFormStart_time(v) {
      if (!this.isEdit) {
        this.scheduleForm.end_time = v && v.getTime() + 3600000;
      }
    }
  },
  computed: {
    errorFormalDate: function errorFormalDate() {
      return function (row) {
        // 已过转正日期，试用期状态仍为试用期中，日期标红显示
        var data = new Date().getTime() > new Date(row.formal_date).getTime() + 86400000;
        if (data && row.formal_state === '1') return true;
        return false;
      };
    }
  },
  methods: {
    init: function init() {
      // 初次进入页面，显示当天的日程列表
      this.handleClick();
      this.getHasSpot();
      this.getAttendanceInfo();
      this.getServingInfo();
      this.getOrgInfo();
      this.getFlowInfo();
      this.getTabCount();
    },
    getStaffRegular: function getStaffRegular(params) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var init, _this2$toRegular, page, page_size, search_name, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 查询待离职
              init = (params === null || params === void 0 ? void 0 : params.init) || false;
              if (init) {
                _this2.toRegular = _objectSpread(_objectSpread({}, _this2.toRegular), {}, {
                  finished: false,
                  page: 1
                });
              }
              _this2.toRegular.loading = true;
              _this2$toRegular = _this2.toRegular, page = _this2$toRegular.page, page_size = _this2$toRegular.page_size, search_name = _this2$toRegular.search_name;
              _context.prev = 4;
              _context.next = 7;
              return _getStaffRegular({
                page: page,
                page_size: page_size,
                search_name: search_name
              });
            case 7:
              res = _context.sent;
              if (res.code === 1) {
                if (res.data.list.length < page_size) _this2.toRegular.finished = true;
                _this2.toRegular.list = init ? res.data.list : _this2.toRegular.list.concat(res.data.list);
              }
              _context.next = 13;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
            case 13:
              _context.prev = 13;
              _this2.toRegular.loading = false;
              if (init) {
                // 待离职人员，滚动加载数据
                _this2.resigTableScrollEvent('regularTable', _this2.toRegular);
              }
              return _context.finish(13);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 11, 13, 17]]);
      }))();
    },
    resigTableScrollEvent: function resigTableScrollEvent(table, data) {
      var _this3 = this;
      if (!this.$refs[table]) return;
      var bodyWrapper = this.$refs[table].bodyWrapper;
      bodyWrapper.addEventListener('scroll', function () {
        if (data.loading || data.finished) return;
        // 滚动距离
        var scrollTop = bodyWrapper.scrollTop;
        // 变量windowHeight是可视区的高度
        var windowHeight = bodyWrapper.clientHeight;
        // 变量scrollHeight是滚动条的总高度
        var scrollHeight = bodyWrapper.scrollHeight;
        if (scrollHeight - scrollTop - windowHeight <= 10) {
          data.page++;
          switch (_this3.activeName) {
            case '2':
              _this3.queryToLeave(); // 待离职列表
              break;
            case '3':
              _this3.getStaffRegular(); // 待转正列表
              break;
          }
        }
      });
    },
    queryToLeave: function queryToLeave(params) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var init, _this4$toResign, page, page_size, search, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 查询待离职
              init = (params === null || params === void 0 ? void 0 : params.init) || false;
              if (init) {
                _this4.toResign = _objectSpread(_objectSpread({}, _this4.toResign), {}, {
                  finished: false,
                  page: 1
                });
              }
              _this4.toResign.loading = true;
              _this4$toResign = _this4.toResign, page = _this4$toResign.page, page_size = _this4$toResign.page_size, search = _this4$toResign.search;
              _context2.prev = 4;
              _context2.next = 7;
              return gettodayleaveoffice({
                page: page,
                page_size: page_size,
                search: search
              });
            case 7:
              res = _context2.sent;
              if (res.code === 1) {
                if (res.data.length < page_size) {
                  _this4.toResign.finished = true;
                }
                _this4.toResign.list = init ? res.data : _this4.toResign.list.concat(res.data);
              }
              _context2.next = 13;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
            case 13:
              _context2.prev = 13;
              _this4.toResign.loading = false;
              if (init) {
                // 待离职人员，滚动加载数据
                _this4.resigTableScrollEvent('resigTable', _this4.toResign);
              }
              return _context2.finish(13);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[4, 11, 13, 17]]);
      }))();
    },
    // 导出待离职列表
    exportExcel: function exportExcel() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var search, res, down_load_excel, object_url, a;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              search = _this5.toResign.search;
              _context3.next = 3;
              return exportleaveoffice({
                search: search
              });
            case 3:
              res = _context3.sent;
              if (res.code === 1) {
                down_load_excel = res.data.down_load_excel;
                object_url = down_load_excel.object_url; // 下载含有url的文件
                a = document.createElement('a'); // 创建a标签
                a.setAttribute('download', ''); // download属性
                a.setAttribute('href', object_url); // href链接
                a.click(); // 自执行点击事件
              }
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getTabCount: function getTabCount() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return tabCount();
            case 2:
              res = _context4.sent;
              if (res.code === 1) {
                _this6.tabCountMap = res.data;
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    keyValueToArr: function keyValueToArr(obj) {
      return Object.entries(obj).map(function (item) {
        return {
          name: item[0],
          value: item[1]
        };
      });
    },
    getAttendanceInfo: function getAttendanceInfo() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return attendanceFn();
            case 2:
              res = _context5.sent;
              if (res.code === 1) {
                _this7.attendanceData = _this7.keyValueToArr(res.data);
              }
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getServingInfo: function getServingInfo() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return servingFn();
            case 2:
              res = _context6.sent;
              if (res.code === 1) {
                _this8.servingData = Object.values(res.data);
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getOrgInfo: function getOrgInfo() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var res;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return orgFn();
            case 2:
              res = _context7.sent;
              if (res.code === 1) {
                _this9.orgData = _this9.keyValueToArr(res.data);
              }
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getFlowInfo: function getFlowInfo(days) {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var res, obj;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return flowFn({
                recent_day: days || 7
              });
            case 2:
              res = _context8.sent;
              if (res.code === 1) {
                obj = {
                  xAxisData: Object.keys(res.data.state_1),
                  entryArr: Object.values(res.data.state_1),
                  leaveArr: Object.values(res.data.state_2)
                };
                _this10.flowData = obj;
              }
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    // 待办提醒列表
    handleGetPendingList: function handleGetPendingList() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var res;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return getPendingList({
                state: '0'
              });
            case 2:
              res = _context9.sent;
              if (res.code === 1) {
                _this11.toDoList = res.data && res.data.data;
              }
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    getHasSpot: function getHasSpot() {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var res, arr;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return hasSpotFn(_this12.dateToTimestamp(new Date()));
            case 2:
              res = _context10.sent;
              if (res.code === 1) {
                arr = Object.keys(res.data);
                _this12.includeSchedule = arr.map(function (item) {
                  return formatDay(item * 1000);
                });
              }
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    // date对象转日期再转时间戳
    dayToTimestamp: function dayToTimestamp(date) {
      if (date) {
        var timestamp = new Date(formatDay(date)).getTime().toString().substr(0, 10);
        return timestamp;
      } else {
        return '';
      }
    },
    // date对象转时间戳
    dateToTimestamp: function dateToTimestamp(date) {
      if (date) {
        var str = date.valueOf().toString().substr(0, 10);
        return str;
      } else {
        return '';
      }
    },
    // 日程列表时间显示：
    // 1、时间戳转“10月27日（周二）16:00-17:00”
    // 2、时间戳转“10月27日（周二）16:00-10月28日（周三）17:00”
    formatTimestamp: function formatTimestamp(row) {
      var showStr = '';
      var startStr = row.start_time * 1000;
      var endStr = row.end_time * 1000;
      var startTime = formatDate(startStr);
      var endTime = formatDate(endStr);
      var endHour = endTime.substr(endTime.indexOf(':') - 1, 2);
      var endMin = endTime.substr(-2);
      // 同一天
      if (new Date(startStr).toDateString() === new Date(endStr).toDateString()) {
        showStr = "".concat(startTime, "-").concat(endHour).concat(endMin);
      } else {
        showStr = "".concat(startTime, "  -  ").concat(endTime);
      }
      return showStr;
    },
    // 日历切换
    dateChange: function dateChange(date) {
      var day = this.dayToTimestamp(date);
      this.getScheduleList(day);
      this.getTabCount();
    },
    getScheduleList: function getScheduleList(day) {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var date, res;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              date = day || _this13.dayToTimestamp(new Date());
              _context11.next = 3;
              return listFn({
                day: date
              });
            case 3:
              res = _context11.sent;
              if (res.code === 1) {
                _this13.scheduleList = res.data;
              }
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    // 删除
    handleDel: function handleDel(id) {
      var _this14 = this;
      var $t = this.$t;
      this.$confirm($t('confirm_delete'), $t('229'), {
        confirmButtonText: $t('131'),
        cancelButtonText: $t('66'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var res;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return delFn({
                id: id
              });
            case 2:
              res = _context12.sent;
              if (res.code === 1) {
                _this14.getScheduleList();
                _this14.getHasSpot();
              }
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))).catch(function () {});
    },
    // 新增/编辑日程
    handleConfirm: function handleConfirm() {
      var _this15 = this;
      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(valid) {
          var _this15$scheduleForm, start_time, end_time, start_date, end_date, start_times, end_times, params, res;
          return _regeneratorRuntime().wrap(function _callee13$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                if (!valid) {
                  _context13.next = 20;
                  break;
                }
                _this15$scheduleForm = _this15.scheduleForm, start_time = _this15$scheduleForm.start_time, end_time = _this15$scheduleForm.end_time;
                start_date = _this15.dayToTimestamp(start_time);
                end_date = _this15.dayToTimestamp(end_time);
                start_times = _this15.dateToTimestamp(start_time);
                end_times = _this15.dateToTimestamp(end_time);
                params = _objectSpread(_objectSpread({}, _this15.scheduleForm), {}, {
                  start_time: start_times,
                  end_time: end_times,
                  start_date: start_date,
                  end_date: end_date
                });
                if (!_this15.isAdd) {
                  _context13.next = 13;
                  break;
                }
                _context13.next = 10;
                return createFn(params);
              case 10:
                _context13.t0 = _context13.sent;
                _context13.next = 16;
                break;
              case 13:
                _context13.next = 15;
                return editFn(params);
              case 15:
                _context13.t0 = _context13.sent;
              case 16:
                res = _context13.t0;
                if (res.code === 1) {
                  _this15.dialogVisible = false;
                  _this15.getScheduleList();
                  // 添加点
                  _this15.getHasSpot();
                }
                _context13.next = 21;
                break;
              case 20:
                return _context13.abrupt("return", false);
              case 21:
              case "end":
                return _context13.stop();
            }
          }, _callee13);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    handleEdit: function handleEdit(row) {
      var _this16 = this;
      this.isAdd = false;
      this.dialogVisible = true;
      this.getTypeList();
      this.isEdit = true;
      this.$nextTick(function () {
        _this16.scheduleForm = _objectSpread(_objectSpread({}, row), {}, {
          start_time: new Date(row.start_time * 1000),
          end_time: new Date(row.end_time * 1000)
        });
      });
    },
    // 日程类型列表
    getTypeList: function getTypeList() {
      var _this17 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var res;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return typeInfoFn();
            case 2:
              res = _context14.sent;
              _this17.scheduleType = res.data.map(function (val, index) {
                return {
                  id: index,
                  name: val
                };
              });
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    // 添加日程
    addSchedule: function addSchedule() {
      this.scheduleForm = scheduleForm();
      this.isEdit = false;
      // 开始时间默认当前时间，结束时间默认一小时以后
      this.scheduleForm = _objectSpread(_objectSpread({}, this.scheduleForm), {}, {
        start_time: new Date(),
        end_time: new Date(new Date().getTime() + 3600000)
      });
      this.isAdd = true;
      this.dialogVisible = true;
      this.getTypeList();
    },
    // tab切换
    handleClick: function handleClick() {
      this.$router.push({
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          active: this.activeName
        })
      });
      switch (this.activeName) {
        case '0':
          this.getScheduleList(); // 日程列表
          break;
        case '1':
          this.handleGetPendingList(); // 待办提醒列表
          break;
        case '2':
          this.queryToLeave({
            init: true
          }); // 待离职列表
          break;
        case '3':
          this.getStaffRegular({
            init: true
          }); // 待转正列表
          break;
      }
    },
    // 同意
    confirmAgree: function confirmAgree(item) {
      var _this18 = this;
      this.isImprove = true;
      this.$nextTick(function () {
        _this18.$refs.improve.init(item);
      });
    },
    // 确认拒绝
    confirmRelod: function confirmRelod(item) {
      var _this19 = this;
      this.$confirm(this.$t('369', {
        name: item.name
      }), this.$t('367'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        inviteApproval(_objectSpread(_objectSpread({}, item), {}, {
          state: 2
        })).then(function (res) {
          _this19.$message.success(_this19.$t('886'));
          _this19.handleGetPendingList();
        });
      });
    },
    // 确认屏蔽
    confirmShield: function confirmShield(item) {
      var _this20 = this;
      this.$confirm(this.$t('370'), this.$t('368'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        inviteApproval(_objectSpread(_objectSpread({}, item), {}, {
          state: 3
        })).then(function (res) {
          _this20.$message.success(_this20.$t('886'));
          _this20.handleGetPendingList();
        });
      });
    },
    setMessage: function setMessage() {
      // 设置提醒
      // 试用期设置
      this.$router.push({
        path: '/staff/pemploymenter/setting',
        query: {
          active: '3',
          name: 'REGULAR_NOTICE_DAY'
        }
      });
    },
    goBack: function goBack() {
      // 返回
      this.isProbationSet = false;
      this.init();
    }
  }
};